var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coins-title"},[_c('img',{attrs:{"src":require("@/assets/icons-file/sku/coins.png")}}),_c('span',[_vm._v(_vm._s(_vm.format(_vm.userCoins)))]),_c('p',[_vm._v("coins available")])])}
var staticRenderFns = []

export { render, staticRenderFns }